export default "__VITE_ASSET__CqggTRBE__"